/**
 * (c) 2015 Ignite Sales, Inc.
 * User: aholmes
 * Date: 6/8/2016
 * Time: 9:28 AM
 */
import {ImmutableStore} from 'fluxible-immutable-utils';
import CommonActions from '../constants/CommonActions';
import {getLocale} from '../../common/i18n/Locale';

const defaultState = {
  messages: {},
  locale: getLocale()
};

class MessageStore extends ImmutableStore {
  static storeName = 'MessageStore';

  static handlers = {
    [CommonActions.LOCALE_CHANGED]: 'handleLocaleChanged',
    [CommonActions.MESSAGES_LOADED]: 'handleMessagesLoaded'
  };

  constructor(dispatcher) {
    super(dispatcher);

    this.setState(defaultState);
  }

  handleLocaleChanged(locale) {
    this.mergeState({
      locale
    });
  }

  handleMessagesLoaded(messages) {
    this.mergeState({
      messages
    });
  }

  getMessages() {
    const messages = this.get(['messages', this.get('locale')]);

    return messages ? messages.toJS() : {};
  }

  getLocale() {
    return this.get('locale');
  }

}

export default MessageStore;



/** WEBPACK FOOTER **
 ** ./src/main/js/common/stores/MessageStore.js
 **/